import React, { useEffect, useState, }  from 'react';
import { useNavigate } from 'react-router-dom';
import { WindowSize } from '../WindowSize.js';
import { useSelector,useDispatch } from 'react-redux';
import fetch from 'node-fetch';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString, isValidEmail, isValidPassword } from '../Utility.js';


function Login() {
    const state=useSelector((state)=>state);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [isLogin, setIsLogin] = useState(true);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [resister_email, setRegisterEmail] = useState('');
    const [register_password, setRegisterPassword] = useState('');
    const [register_password_confirm, setRegisterPasswordConfirm] = useState('');
    const [register_handphone, setRegisterHandphone] = useState('');
    const [register_username, setRegisterUserName] = useState('');
    const [register_nickname, setRegisterNickName] = useState('');
    const [register_recommand, setRegisterRecommand] = useState('');
    
    const width = 1920;
    const height = 1080;
  
    const checkMobile = () => {
      const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  
      if (varUA.indexOf('android') > -1) {
        //안드로이드
        return "android";
      } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    }

    const FindPassword = async (email) => 
      {
          try
          {
              
              dispatch({type:'Request'});
              const response = await fetch(GetUrl() + 'FindPassword/FindPassword', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ email : email }),
              });
  
              if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                  alert('패스워드 : ' + data.password);
                }
                else if(data.result === 1)
                {
                  alert('가입 한 회원이 아닙니다.');  
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
  
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                }
            } else {
                alert('Network fail');
            }
  
            dispatch({type:'Response'});
          }
          catch(error)
          {
              dispatch({type:'Response'});
              console.error(error);
          }
      };

    const CheckMaintenance = async () => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetMaintenanceUrl() + 'CheckMaintenance/CheckMaintenance', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empty : 'empty' }),
            });

            if (response.ok) {
                const data = await response.json();

                if(data.maintenance === 0) // 점검 없음
                {
                }
                else if(data.maintenance === 1) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);

                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                }
                else if(data.maintenance === 2) // 점검 예정
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);

                  var message = `${startTime} ~ ${endTime} 점검 예정 입니다. 서비스 이용해 참고 해 주세요`;
                  alert(message);  
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            dispatch({type:'Response'});
            console.error(error);
        }
    };

      useEffect(() => {

          const loginMsg = (event) => {
            try
            {  
                const data = JSON.parse(event.data);
                if(data.msg === "login")
                {
                  dispatch({type:'Response'});
                  if(data.status === "success")
                  {
                    setIsLogin(false);
                    setRegisterEmail(data.id);
                  }
                  else if(data.status === "error")
                  {
                    alert('구글 인증 실패 ' + data.error);
                  }
                }
                else if(data.msg === "findpassword")
                {
                  dispatch({type:'Response'});
                  if(data.status === "success")
                  {
                    FindPassword(data.id);
                  }
                  else if(data.status === "error")
                  {
                    alert('구글 인증 실패 ' + data.error);
                  }
                }
            }
            catch(error)
            {
                dispatch({type:'Response'});
            }
          }

          window.addEventListener("message", loginMsg);
          document.addEventListener("message", loginMsg);
      
          return () => {
              window.removeEventListener("message", loginMsg);
              document.removeEventListener("message", loginMsg);
          };
        }, []);
  
    useEffect(() => {
      const isDevToolsMobileEmulation = () => {
        return /\bMobile/.test(navigator.userAgent) && !('ontouchstart' in window);
      };
  
      const handleSize = (event = null) => {
        if (isDevToolsMobileEmulation()) {
        
          // Logic for when Chrome Developer Tools' Mobile View is toggled on
          if (window.innerWidth > 480) {
            WindowSize(width, height, 'PC90', height, 'no');
            
          }
          else {
            WindowSize(width, height, 'ELSE', height, 'no');
            
          }
        }
        else {
          if (window.innerWidth > 480) {
            WindowSize(width, height, 'PC90', height, checkMobile());
           
          }
          else {
            WindowSize(width, height, 'ELSE', height, checkMobile());
           
          }
        }
      }
  
      window.addEventListener('orientationchange', handleSize);
      window.addEventListener('resize', handleSize);
      handleSize();

      CheckMaintenance();

      return () => {
        window.removeEventListener('resize', handleSize);
        window.removeEventListener('orientationchange', handleSize);
      };
  
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        try
        {
          if(state.Request === 1)
          {
            return;
          }

          const userCode = localStorage.getItem("UserCode") || "";

          dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Game/Login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'
             },
            body: JSON.stringify({ email : email, pass : password, ad_usercode : userCode }),
          });

          if (response.ok) {
              const data = await response.json();
              
              if(data.result === 0)
              {
                localStorage.removeItem("UserCode");
                sessionStorage.setItem("secret_key", data.secret_key);
                navigate('/main'); // 로그인 성공 시 메인 페이지로 이동
              }
              else if(data.result === 1)
              {
                alert('로그인 실패(아이디를 확인 해 주세요)');  
              }
              else if(data.result === 2)
              {
                alert('로그인 실패(패스워드를 확인 해 주세요)');  
              }
              else if(data.result === 21) // 점검 중
              {
                var startTime = CTicksToDateString(data.start_time);
                var endTime = CTicksToDateString(data.end_time);

                var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                alert(message);  
              }
          } else {
              alert('Network fail');
          }

          dispatch({type:'Response'});
        }
        catch(error)
        {
          dispatch({type:'Response'});
          console.error(error);
        }
    };

    const handleRegister = async (e) => {
      e.preventDefault();
      try
      {
        if(resister_email === "")
        {
          alert('회원 가입 실패(이메일을 입력 해 주세요)');  
          return;
        }

        if(isValidEmail(resister_email) === false)
        {
          alert('회원 가입 실패(유효하지 않은 이메일 형식입니다)');  
          return;
        }

        if(register_password === "")
        {
          alert('회원 가입 실패(비밀번호를 입력 해 주세요)');  
          return;
        }

        if(register_password_confirm === "")
        {
          alert('회원 가입 실패(비밀번호 확인 을 입력 해 주세요)');  
          return;
        }
        
        if(register_handphone === "")
        {
          alert('회원 가입 실패(핸드폰 번호를 입력 해 주세요)');  
          return;
        }

        if(register_username === "")
        {
          alert('회원 가입 실패(가입자 명을 입력 해주세요)');  
          return;
        }

        if(register_nickname === "")
        {
          alert('회원 가입 실패(닉네임을 입력 해 주세요)');  
          return;
        }

        if(register_recommand === "")
        {
          const result = window.confirm("추천인을 입력 하지 않으셨습니다. 이대로 진행 할까요?");
          if(result === false)
          {
            return;
          }
        }
        else
        {
          if(isValidEmail(register_recommand) === false)
          {
            alert('회원 가입 실패(유효하지 않은 추천인 이메일 형식입니다)');  
            return;
          }
        }

        if(register_password != register_password_confirm)
        {
          alert('회원 가입 실패(비밀번호 와 비밀번호 확인이 일치 하지 않습니다.)');  
          return;
        }

        if(isValidPassword(register_password) === false)
        {
          alert('회원 가입 실패(비밀번호는 8자리 이상 특수 문자 표함 해야 합니다.)');  
          return;
        }
    
        if(state.Request === 1)
        {
          return;
        }

        dispatch({type:'Request'});
        const response = await fetch(GetUrl() + 'Register/Register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'
           },
          body: JSON.stringify({ email : resister_email, password : register_password, handphone : register_handphone, user_name : register_username, nick_name : register_nickname, recommand_email : register_recommand  }),
        });

        if (response.ok) {
            const data = await response.json();
            
            if(data.result === 0)
            {
              alert('회원 가입 성공(꼭 도움말 확인 후 사용해 주세요)');  
              setIsLogin(true);
            }
            else if(data.result === 5)
            {
              alert('회원 가입 실패(동일한 이메일이 이미 사용 중입니다.)');  
            }
            else if(data.result === 4)
            {
              alert('회원 가입 실패(동일한 닉네임이 이미 사용 중입니다.)');  
            }
            else if(data.result === 7)
            {
              alert('회원 가입 실패(이메일을 입력 해 주세요)');  
            }
            else if(data.result === 8)
            {
              alert('회원 가입 실패(닉네임을 입력 해 주세요)');  
            }
            else if(data.result === 9)
            {
              alert('회원 가입 실패(비밀번호를 입력 해 주세요)');  
            }
            else if(data.result === 10)
            {
              alert('회원 가입 실패(핸드폰 번호를 입력 해 주세요)');  
            }
            else if(data.result === 11)
            {
              alert('회원 가입 실패(가입자 명을 입력 해주세요)');  
            }
            else if(data.result === 21) // 점검 중
            {
              var startTime = CTicksToDateString(data.start_time);
              var endTime = CTicksToDateString(data.end_time);

              var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
              alert(message);  
            }
            else if(data.result === 19)
            {
              alert('회원 가입 실패');
            }
            else if(data.result === 23)
            {
              alert('회원 가입 실패(존재 하지 않는 추천인 이메일 입니다.)');  
            }
        } else {
            alert('Network fail');
        }

        dispatch({type:'Response'});
      }
      catch(error)
      {
        dispatch({type:'Response'});
        console.error(error);
      }
  };

    const RegisterClick = async (e) =>
    {
      if(state.Request === 1)
      {
          return;
      }
      
      if (window.ReactNativeWebView) {
        dispatch({type:'Request'});
        window.ReactNativeWebView.postMessage(JSON.stringify({ msg : 'login', data:'' }));
      } else {
        alert('Google Play Store에서 다운로드 후 이용 부탁 드립니다.');
      }
    };

    const FindPasswordClick = async (e) =>
    {
      if(state.Request === 1)
      {
          return;
      }
      
      if (window.ReactNativeWebView) {
        dispatch({type:'Request'});
        window.ReactNativeWebView.postMessage(JSON.stringify({ msg : 'findpassword', data:'' }));
      } else {
        alert('Google Play Store에서 다운로드 후 이용 부탁 드립니다.');
      }
    };

    return (
        <div id='login-box'>
          <div id="loginform" style={{ display: isLogin ? 'block' : 'none' }}>
              <form className="login-form" onSubmit={handleLogin}>
                  <h2>로그인</h2>
                  <input
                      type="text"
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                  />
                  <button type="submit">로그인</button>
              </form>
              <div className="register-link">
                <a href="#" id="showRegister" onClick={(e) => { e.preventDefault(); RegisterClick();}}>회원가입</a> | <a href="#" onClick={(e) => { e.preventDefault(); FindPasswordClick();}}>비밀번호를 잊으셨나요?</a>
              </div>
            </div>
            <div id="registerform" style={{ display: isLogin ? 'none' : 'block' }}>
            <form className="register-form" onSubmit={handleRegister}>
                  <h2>회원가입</h2>
                  <input
                      type="text"
                      placeholder="이메일"
                      value={resister_email}
                      disabled
                  />
                  <input
                      type="password"
                      placeholder="비밀번호(8자리 이상 특수 문자 표함)"
                      value={register_password}
                      onChange={(e) => setRegisterPassword(e.target.value)}
                  />
                  <input
                      type="password"
                      placeholder="비밀번호 확인(8자리 이상 특수 문자 표함)"
                      value={register_password_confirm}
                      onChange={(e) => setRegisterPasswordConfirm(e.target.value)}
                  />
                  <input
                      type="name"
                      placeholder="가입자 명"
                      value={register_username}
                      onChange={(e) => setRegisterUserName(e.target.value)}
                  />
                  <input
                      type="nickname"
                      placeholder="닉 네임"
                      value={register_nickname}
                      onChange={(e) => setRegisterNickName(e.target.value)}
                  />
                  <input
                      type="handphone"
                      placeholder="휴대폰 번호"
                      value={register_handphone}
                      onChange={(e) => setRegisterHandphone(e.target.value)}
                  />
                  <input
                      type="text"
                      placeholder="추천인 이메일"
                      value={register_recommand}
                      onChange={(e) => setRegisterRecommand(e.target.value)}
                  />
                  <button type="submit">회원가입</button>
              </form>
              <div className="register-link">
                <a href="#" id="showLogin" onClick={(e) => { e.preventDefault(); setIsLogin(true);}}>로그인으로 돌아가기</a>
              </div>
            </div>
        </div>
    );
}

export default Login;